var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6506 6.31117C15.1542 6.31117 16.448 4.96838 16.448 3.21999C16.448 1.49258 15.1472 0.212769 13.6506 0.212769C12.154 0.212769 10.8532 1.52056 10.8532 3.23399C10.8532 4.96838 12.147 6.31117 13.6506 6.31117ZM5.601 6.47203C6.90182 6.47203 8.03479 5.29711 8.03479 3.7795C8.03479 2.27589 6.89484 1.16388 5.601 1.16388C4.30022 1.16388 3.15329 2.30384 3.16027 3.7935C3.16027 5.29711 4.29324 6.47203 5.601 6.47203ZM1.6986 12.7872H7.01372C6.28641 11.7312 7.17457 9.60515 8.67819 8.44422C7.90192 7.92669 6.90182 7.54202 5.59402 7.54202C2.43993 7.54202 0.467743 9.87089 0.467743 11.8081C0.467743 12.4375 0.817407 12.7872 1.6986 12.7872ZM9.25166 12.7872H18.0425C19.1405 12.7872 19.5323 12.4725 19.5323 11.8571C19.5323 10.0527 17.2733 7.563 13.6436 7.563C10.021 7.563 7.76204 10.0527 7.76204 11.8571C7.76204 12.4725 8.15368 12.7872 9.25166 12.7872Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7c9a418ef22f9dfe6135f9369898018c.svg";
export { ForwardRef as ReactComponent };